import { Box } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import * as appActions from 'Actions/app';
import { isRepertoireCreateAvailable } from './createAvailability';
import { isRepertoireLibraryAvailable } from './libraryAvailability';
import { MobileMenuButton } from 'Components/RoadmapComponents/Menu';

interface PageNavProps {
  selected: string;
  onMenuOpen?: () => void;
}

const PageNav = ({ selected, onMenuOpen }: PageNavProps) => {
  const _navigate = useNavigate();
  const dispatch = useDispatch();
  const showCreateTab = isRepertoireCreateAvailable();
  const showLibraryTab = isRepertoireLibraryAvailable();

  return (
    <Box
      sx={{
        zIndex: 15,
        backgroundColor: '#040B13',
        height: 'var(--rep-nav-height, 100px)',
        display: 'flex',
        alignItems: 'flex-end',
      }}
    >
      <Box
        sx={{
          marginLeft: '16px',
          display: 'flex',
          alignItems: 'center',
          gap: '16px',
          paddingBottom: '8px',
          overflowX: 'auto',
          scrollbarWidth: 'none',
          '&::-webkit-scrollbar': {
            display: 'none',
          },
          '@media (max-width: 640px), (pointer: coarse)': {
            gap: '8px',
            marginLeft: '10px',
            paddingRight: '10px',
          },
        }}
      >
        {onMenuOpen && <MobileMenuButton inline onClick={onMenuOpen} />}
        <Box
          component="button"
          type="button"
          data-repertoire-nav-button="home"
          aria-current={selected == 'Home' ? 'page' : undefined}
          sx={selected == 'Home' ? { ...selectStyles, ...selectSelectedStyles } : selectStyles}
          // onClick={() => navigate("/home")}
          onClick={() => dispatch(appActions.setRepPageSelected('Home'))}
        >
          <Box component="span" sx={textStyles}>
            Home
          </Box>
        </Box>
        <Box
          component="button"
          type="button"
          data-repertoire-nav-button="browse"
          aria-current={selected == 'Browse' ? 'page' : undefined}
          sx={selected == 'Browse' ? { ...selectStyles, ...selectSelectedStyles } : selectStyles}
          // onClick={() => navigate("/browse")}
          onClick={() => dispatch(appActions.setRepPageSelected('Browse'))}
        >
          <Box component="span" sx={textStyles}>
            Browse
          </Box>
        </Box>
        {showCreateTab && (
          <Box
            component="button"
            type="button"
            data-repertoire-nav-button="create"
            aria-current={selected == 'Create' ? 'page' : undefined}
            sx={selected == 'Create' ? { ...selectStyles, ...selectSelectedStyles } : selectStyles}
            onClick={() => dispatch(appActions.setRepPageSelected('Create'))}
          >
            <Box component="span" sx={textStyles}>
              Create
            </Box>
          </Box>
        )}
        {showLibraryTab && (
          <Box
            component="button"
            type="button"
            data-repertoire-nav-button="library"
            aria-current={selected == 'Library' ? 'page' : undefined}
            sx={selected == 'Library' ? { ...selectStyles, ...selectSelectedStyles } : selectStyles}
            onClick={() => dispatch(appActions.setRepPageSelected('Library'))}
          >
            <Box component="span" sx={textStyles}>
              Library
            </Box>
          </Box>
        )}
      </Box>
    </Box>
  );
};
export default PageNav;

const selectStyles = {
  color: 'white',
  margin: '0 5px',
  padding: '8px 32px 10px',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  minHeight: '44px',
  border: 0,
  borderBottom: '2px solid transparent',
  borderRadius: '5px',
  background: 'transparent',
  appearance: 'none',
  WebkitAppearance: 'none',
  WebkitTapHighlightColor: 'transparent',
  touchAction: 'manipulation',
  cursor: 'pointer',
  flexShrink: 0,
  '@media (hover: hover) and (pointer: fine)': {
    '&:hover': {
      background: 'rgb(202,124,98,.25)',
      transition: 'background-color 0.15s ease, box-shadow 0.15s ease',
      boxShadow: '0px 0px 5px 5px rgb(202,124,98,.25)',
    },
  },
  '&:active': {
    background: 'rgb(202,124,98,.25)',
    boxShadow: '0px 0px 5px 5px rgb(202,124,98,.25)',
  },
  '&:focus-visible': {
    outline: '2px solid #6F87F1',
    outlineOffset: '2px',
  },
  '@media (max-width: 640px), (pointer: coarse)': {
    margin: 0,
    padding: '8px 18px 10px',
  },
};

const selectSelectedStyles = {
  borderBottom: '2px solid',
  borderColor: '#6F87F1',
  color: '#6F87F1',
};

const textStyles = {
  fontFamily: 'Lato',
  fontStyle: 'normal',
  fontWeight: '700',
  fontSize: '15px',
  lineHeight: '24px',
  letterSpacing: '1px',
  whiteSpace: 'nowrap',
};
